import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../LanguageContext';
export const Urgency = () => {
  const {
    language
  } = useLanguage();
  return <section className="py-16 bg-brand-pink relative overflow-hidden border-y border-brand-gold/20" data-id="element-428">
      {/* Subtle background pattern/texture */}
      <div className="absolute inset-0 opacity-10 mix-blend-overlay" style={{
      backgroundImage: 'radial-gradient(circle at 2px 2px, white 1px, transparent 0)',
      backgroundSize: '24px 24px'
    }} data-id="element-429"></div>

      <div className="container mx-auto px-6 max-w-4xl relative z-10 text-center" data-id="element-430">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="max-w-4xl mx-auto text-center" data-id="element-431">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-serif text-brand-charcoal mb-4" data-id="element-432">
            {language === 'es' ? 'Atención exclusiva y personalizada' : 'Exclusive and personalized attention'}
          </h2>
          <p className="text-lg text-brand-charcoal/80 mb-8 max-w-2xl mx-auto font-light" data-id="element-433">
            {language === 'es' ? 'Para garantizar la máxima calidad en cada tratamiento, atiendo a un número limitado de pacientes por semana. Asegura tu espacio con anticipación.' : 'To guarantee the highest quality in every treatment, I attend to a limited number of patients per week. Secure your spot in advance.'}
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-6 text-brand-charcoal font-medium" data-id="element-434">
            <div className="flex items-center gap-2" data-id="element-435">
              <span className="w-2 h-2 rounded-full bg-brand-gold animate-pulse" data-id="element-436"></span>
              {language === 'es' ? 'Cupos limitados este mes' : 'Limited spots this month'}
            </div>
            <div className="hidden sm:block w-px h-6 bg-brand-gold/30" data-id="element-437"></div>
            <div className="flex items-center gap-2" data-id="element-438">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-brand-gold" data-id="element-439">
                <rect x="3" y="4" width="18" height="18" rx="2" ry="2" data-id="element-440"></rect>
                <line x1="16" y1="2" x2="16" y2="6" data-id="element-441"></line>
                <line x1="8" y1="2" x2="8" y2="6" data-id="element-442"></line>
                <line x1="3" y1="10" x2="21" y2="10" data-id="element-443"></line>
              </svg>
              {language === 'es' ? 'Solo con cita previa' : 'By appointment only'}
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
};